(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hemmie-product-v5"] && !Shopify.designMode) return;
  try {
    
const section=document.currentScript?.closest('.shopify-section')||document;
const productRoot=section.querySelector('[data-product-section]');
if(productRoot){
  const isTouchLayout=window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  const hasPhoneUserAgent=Boolean(navigator.userAgentData?.mobile)
    || /Android|iPhone|iPod|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
  const isCompactTouchDevice=isTouchLayout
    && navigator.maxTouchPoints>0
    && Math.min(window.screen.width,window.screen.height)<=800;
  const isPhoneDevice=hasPhoneUserAgent || isCompactTouchDevice;
  if(isPhoneDevice) productRoot.classList.add('hmp--phone-device');

  const json=section.querySelector('[data-product-json]');
  const variants=json?JSON.parse(json.textContent):[];
  const selected={};
  const mediaItems=[...productRoot.querySelectorAll('[data-media-id]')];
  const thumbButtons=[...productRoot.querySelectorAll('[data-thumb-media-id]')];
  const galleryStage=productRoot.querySelector('.hmp__stage');
  const setActiveMedia=(mediaId)=>{
    if(!mediaId) return;
    mediaItems.forEach(item=>item.classList.toggle('is-active',String(item.dataset.mediaId)===String(mediaId)));
    thumbButtons.forEach(btn=>btn.classList.toggle('is-active',String(btn.dataset.thumbMediaId)===String(mediaId)));
    if(galleryStage && (isTouchLayout || productRoot.classList.contains('hmp--phone-device') || window.matchMedia('(max-width: 560px)').matches)){
      const target=mediaItems.find(item=>String(item.dataset.mediaId)===String(mediaId));
      if(target) galleryStage.scrollTo({left:target.offsetLeft,behavior:'smooth'});
    }
  };

  const normalize=(value)=>String(value||'').trim().toLowerCase();
  const optionTokens=(value)=>normalize(value).split(/[^\p{L}\p{N}]+/u).filter(Boolean);

  const sileaDescriptionSource=productRoot.querySelector('[data-silea-description-source]');
  if(sileaDescriptionSource){
    const sectionTargets={};
    productRoot.querySelectorAll('[data-silea-section]').forEach(target=>{
      sectionTargets[target.dataset.sileaSection]=target;
    });

    const sectionFromHeading=(heading)=>{
      const text=normalize(heading);
      if(/retur|garanti|reklamation/.test(text)) return 'returer';
      if(/leverans|frakt/.test(text)) return 'leverans';
      if(/installation|montering/.test(text)) return 'installation';
      if(/material|specifikation|mått|dimension|storlek|teknisk|ljuskälla|watt|effekt/.test(text)) return 'specifikationer';
      if(/produktinformation|beskrivning|om lampan|design/.test(text)) return 'productinformation';
      return null;
    };

    const parsed={productinformation:[],specifikationer:[],installation:[],leverans:[],returer:[]};
    let activeSection='productinformation';
    [...sileaDescriptionSource.children].forEach(node=>{
      const isHeading=/^H[1-6]$/.test(node.tagName);
      const matchedSection=isHeading ? sectionFromHeading(node.textContent) : null;
      if(matchedSection){
        activeSection=matchedSection;
        return;
      }
      parsed[activeSection].push(node.cloneNode(true));
    });

    Object.entries(parsed).forEach(([key,nodes])=>{
      if(!nodes.length || !sectionTargets[key]) return;
      sectionTargets[key].replaceChildren(...nodes);
    });

    if(!parsed.productinformation.length && sileaDescriptionSource.innerHTML.trim()){
      sectionTargets.productinformation.innerHTML=sileaDescriptionSource.innerHTML;
    }
  }

  const findMediaFromSelectedValues=()=>{
    const selectedValues=Object.values(selected).map(normalize).filter(Boolean);
    if(!selectedValues.length) return null;

    const exactMatch=mediaItems.find(item=>{
      const alt=normalize(item.dataset.mediaAlt);
      return selectedValues.every(value=>alt.includes(value));
    });
    if(exactMatch) return exactMatch.dataset.mediaId;

    const selectedTokens=selectedValues.flatMap(optionTokens);
    const tokenMatch=mediaItems.find(item=>{
      const alt=normalize(item.dataset.mediaAlt);
      return selectedTokens.length && selectedTokens.every(token=>alt.includes(token));
    });
    if(tokenMatch) return tokenMatch.dataset.mediaId;

    const partialMatch=mediaItems.find(item=>{
      const alt=normalize(item.dataset.mediaAlt);
      return selectedValues.some(value=>alt.includes(value));
    });
    return partialMatch ? partialMatch.dataset.mediaId : null;
  };

  const applyVariant=(variant)=>{
    if(!variant) return;
    const variantIdInput=productRoot.querySelector('[data-variant-id]');
    if(variantIdInput){
      variantIdInput.value=variant.id;
      variantIdInput.dispatchEvent(new Event('change',{bubbles:true}));
    }

    const hideUnavailablePrice=!variant.available && Number(variant.price)===0;
    const priceEl=productRoot.querySelector('[data-price]');
    if(priceEl){
      priceEl.textContent=hideUnavailablePrice?priceEl.dataset.unavailablePriceLabel:variant.price_formatted;
    }

    const hasSale=!hideUnavailablePrice && Number(variant.compare_at_price)>variant.price;
    const compareEl=productRoot.querySelector('[data-hbf-compare]');
    if(compareEl){compareEl.hidden=!hasSale;compareEl.textContent=hasSale?variant.compare_formatted:'';}
    const savingEl=productRoot.querySelector('[data-hbf-saving]');
    if(savingEl){savingEl.hidden=!hasSale;savingEl.textContent=hasSale?savingEl.dataset.label.replace('__AMOUNT__',variant.saving_formatted):'';}
    const campaignPromo=productRoot.querySelector('[data-hbf-product-promo]');
    if(campaignPromo) campaignPromo.hidden=!hasSale;
    const add=productRoot.querySelector('.hmp__add');
    if(add) add.disabled=!variant.available;
    const availability=productRoot.querySelector('[data-hbf-availability]');
    if(availability) availability.textContent=variant.available?availability.dataset.availableLabel:availability.dataset.soldOutLabel;

    const addText=productRoot.querySelector('[data-add-text]');
    if(addText) addText.textContent=variant.available?'Lägg i varukorgen':'Slutsåld';

    const mediaId=variant.featured_media_id || findMediaFromSelectedValues();
    if(mediaId) setActiveMedia(mediaId);

    const variantUrl=new URL(location.href);
    variantUrl.searchParams.set('variant',variant.id);
    history.replaceState({},'',`${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`);
  };

  productRoot.querySelectorAll('[data-option-position]').forEach(btn=>{
    if(btn.matches('select')) return;
    if(btn.classList.contains('is-active')) selected[Number(btn.dataset.optionPosition)]=btn.dataset.optionValue;
    btn.addEventListener('click',()=>{
      const pos=Number(btn.dataset.optionPosition);
      selected[pos]=btn.dataset.optionValue;
      productRoot.querySelectorAll(`[data-option-position="${pos}"]`).forEach(el=>el.classList.remove('is-active'));
      btn.classList.add('is-active');
      const variant=variants.find(v=>v.options.every((value,index)=>normalize(selected[index+1])===normalize(value)));
      applyVariant(variant);
    });
  });

  productRoot.querySelectorAll('select[data-option-position]').forEach(select=>{
    const pos=Number(select.dataset.optionPosition);
    selected[pos]=select.value;
    select.addEventListener('change',()=>{
      selected[pos]=select.value;
      const variant=variants.find(v=>v.options.every((value,index)=>normalize(selected[index+1])===normalize(value)));
      applyVariant(variant);
    });
  });

  thumbButtons.forEach(btn=>{
    btn.addEventListener('click',()=>setActiveMedia(btn.dataset.thumbMediaId));
  });

  if(galleryStage && mediaItems.length>1){
    let swipeStartX=null;
    let swipeStartY=null;

    const resetSwipe=()=>{
      swipeStartX=null;
      swipeStartY=null;
    };

    galleryStage.addEventListener('touchstart',event=>{
      if(!window.matchMedia('(min-width: 561px) and (max-width: 980px)').matches || event.touches.length!==1) return;
      if(event.target.closest('video, model-viewer, iframe, button, a')) return;
      swipeStartX=event.touches[0].clientX;
      swipeStartY=event.touches[0].clientY;
    },{passive:true});

    galleryStage.addEventListener('touchend',event=>{
      if(swipeStartX===null || swipeStartY===null || !event.changedTouches.length){
        resetSwipe();
        return;
      }

      const deltaX=event.changedTouches[0].clientX-swipeStartX;
      const deltaY=event.changedTouches[0].clientY-swipeStartY;
      resetSwipe();

      if(Math.abs(deltaX)<40 || Math.abs(deltaX)<=Math.abs(deltaY)*1.15) return;

      const activeIndex=mediaItems.findIndex(item=>item.classList.contains('is-active'));
      if(activeIndex<0) return;

      const nextIndex=Math.max(0,Math.min(mediaItems.length-1,activeIndex+(deltaX<0?1:-1)));
      if(nextIndex===activeIndex) return;

      setActiveMedia(mediaItems[nextIndex].dataset.mediaId);
      thumbButtons[nextIndex]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    },{passive:true});

    galleryStage.addEventListener('touchcancel',resetSwipe,{passive:true});
  }

  const initialVariant=variants.find(v=>String(v.id)===String(productRoot.querySelector('[data-variant-id]')?.value)) || variants[0];
  applyVariant(initialVariant);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
